import React, { useState, useEffect, useMemo, useCallback } from "react";

// @mui material components
import Divider from "@mui/material/Divider";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import Grid from "@mui/material/Grid";

// Custom styles for the Modal
import ModalRoot from "containers/modal/ModalRoot";
import CustomButton from "containers/CustomButton";
import { Autocomplete, Chip, Icon, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Createable from "containers/Select";
import { InputOption } from "utils/common";

import { AddRecipe, EditRecipe } from "store/features/recipes";
import MultipleTags from "containers/Tags";
import { updateFirstLetter } from "utils/helper";
import ModalHeader from "containers/modal-header";
import NutritionModal from "components/NutritionValueModal";
import RichTextEditor from "components/RichTextEditor";
import { useRef } from "react";


function Modal({
  open,
  handleCloseModal,
  selectedItem,
  setSelectedItem,
  uid,
  isFetching,
  isSuccess,
  isError,
  setLoader,
  message,
  mode,
  editHandler,
  viewHandler,
}) {
  //default modal fields value
  const defaultHandler = useMemo(() => {
    return {
      name: null,
      description: null,
      preparation: null,
      calories: null,
      weight: null,
      foodType: null,
      ingredients: null,
      groceryList: null,
      nutritions: null,
      howToTake: null,
      qty: null,
      unit: null,
      foodCategory: null,
      // toggleType: null,
    };
  }, []);

  //error handler
  const errorDefault = useMemo(() => {
    return {
      name: false,
      description: false,
      preparation: false,
      calories: false,
      weight: false,
      foodType: false,
      ingredients: false,
      nutritions: false,
      howToTake: false,
      qty: false,
      unit: false,
      foodCategory: false,
    };
  }, []);

  const dispatch = useDispatch();

  const [formdata, setFormdata] = useState(defaultHandler);
  const [errorMessage, setErrorMessage] = useState(errorDefault);

  const sanitizeFoodCategory = (data) => {
    if (Array.isArray(data)) {
      return data
        .map((cat) =>
          typeof cat === "string"
            ? { label: cat, value: cat }
            : typeof cat === "object" && cat?.value
              ? cat
              : null
        )
        .filter(Boolean);
    }
    if (typeof data === "string" && data.trim() !== "") {
      return [{ label: data, value: data }];
    }

    return [];
  };
//  Top of component — only once
  const lastNutritionsRef = useRef(null);
  const normalizeType = (inputType) => {
    const input = inputType.toLowerCase();

    const matched = nutritionOptions.find(
      (opt) => input === opt.toLowerCase() || input.includes(opt.toLowerCase()) || opt.toLowerCase().includes(input)
    );

    return matched || inputType;
  };
 
  //for handling selected items
  useEffect(() => {
    if (!open || !selectedItem || formdata.id === selectedItem.id) return;

    const sanitizedUnit =
      typeof selectedItem.unit === "string"
        ? { label: selectedItem.unit, value: selectedItem.unit }
        : selectedItem.unit ?? { label: "", value: "" };

    //  Don't touch: foodCategory and unit
    const sanitizedFoodCategory = sanitizeFoodCategory(selectedItem.foodCategory);

    //  Nutrition sanitizer — convert string[] to object[]
    const sanitizeNutritions = (data) => {
      if (!Array.isArray(data)) return [];

      return data
        .map((item) => {
          if (typeof item === "string") {
            const [type, valueWithUnit] = item.split(":").map((i) => i.trim());
            const match = valueWithUnit?.match(/^(\d+(?:\.\d+)?)(mg|g)$/i);
            if (match) {
              return {
                type: normalizeType(type),
                grams: match[1],
                unit: match[2],
              };
            }
          } else if (
            typeof item === "object" &&
            item.type &&
            item.grams &&
            item.unit
          ) {
            return {
              type: normalizeType(item.type),
              grams: item.grams,
              unit: item.unit,
            };
          }
          return null;
        })
        .filter(Boolean);
    };




    const sanitizedNutritions = sanitizeNutritions(selectedItem?.nutritions);
    //  Only update selectedOptions if value changed
    const prev = JSON.stringify(lastNutritionsRef.current ?? []);
    const next = JSON.stringify(sanitizedNutritions);

    if (prev !== next) {
      setSelectedOptions(sanitizedNutritions);
      lastNutritionsRef.current = sanitizedNutritions;
    } else {
      console.log(" Skipped selectedOptions (unchanged)");
    }

    // Don't touch nutritions in formdata
    setFormdata({
      ...defaultHandler,
      ...selectedItem,
      foodCategory: sanitizedFoodCategory,
      unit: sanitizedUnit,
      //  NOT setting nutritions here
    });
  }, [open]);



  //for submitting data
  const submitHandler = async (e) => {

    console.log("formdata", formdata);
    if (!formdata.name) {
      toast.error("Please enter a Recipe Name");
      setErrorMessage({
        ...errorMessage,
        name: true,
      });
      return;
    }

    // if (!formdata.description) {
    //   toast.error("Please fill Recipe Description field");
    //   setErrorMessage({
    //     ...errorMessage,
    //     description: true,
    //   });
    //   return;
    // }

    // if (!formdata.preparation) {
    //   toast.error("Please fill How to Prepare field");
    //   setErrorMessage({
    //     ...errorMessage,
    //     preparation: true,
    //   });
    //   return;
    // }

    // if(!formdata.calories){
    //     toast.error("Please fill Calories field")
    //     setErrorMessage({
    //         ...errorMessage,
    //         calories: true
    //     })
    //     return;
    // }

    // if(!formdata.weight){
    //     toast.error("Please fill Weight field")
    //     setErrorMessage({
    //         ...errorMessage,
    //         weight: true
    //     })
    //     return;
    // }

    // if (!formdata.foodType || formdata.foodType?.length === 0) {
    //   toast.error("Please fill Food Type field");
    //   setErrorMessage({
    //     ...errorMessage,
    //     foodType: true,
    //   });
    //   return;
    // }

    // if (!formdata.ingredients || formdata.ingredients?.length === 0) {
    //   toast.error("Please fill Ingredients field");
    //   setErrorMessage({
    //     ...errorMessage,
    //     ingredients: true,
    //   });
    //   return;
    // }

    // if(!formdata.nutritions || formdata.nutritions?.length === 0 ){
    //     toast.error("Please fill Nutrition Value field")
    //     setErrorMessage({
    //         ...errorMessage,
    //         nutritions: true
    //     })
    //     return;
    // }

    // if (!formdata.howToTake) {
    //   toast.error("Please fill How to Take field");
    //   setErrorMessage({
    //     ...errorMessage,
    //     howToTake: true,
    //   });
    //   return;
    // }

    if (!formdata.foodCategory || formdata.foodCategory.length === 0) {
      toast.error("Please fill Food Category field");
      setErrorMessage({
        ...errorMessage,
        foodCategory: true,
      });
      return;
    }

    if (formdata.qty === "" || formdata.qty === null) {
      toast.error("Please fill QTY. field");
      setErrorMessage({
        ...errorMessage,
        qty: true,
      });
      return;
    }

    if (!formdata.unit.value) {
      toast.error("Please fill Unit field");
      setErrorMessage({
        ...errorMessage,
        unit: true,
      });
      return;
    }

    // Sanitize foodCategory and unit before dispatch
    const sanitizedFormdata = {
      ...formdata,
      foodCategory: formdata.foodCategory.map(cat => cat.value),
      unit: formdata.unit?.value || "",
    };


    setLoader(true);

    if (selectedItem) {
      dispatch(EditRecipe({ formdata: sanitizedFormdata, uid }));
      return;
    }

    dispatch(AddRecipe({ formdata: sanitizedFormdata, uid }));
  };

  useEffect(() => {
    if (isSuccess) {
      handleCloseModal();
      setTimeout(() => {
        if (selectedItem) {
          setSelectedItem(null);
        }
        setLoader(false);
        setFormdata({
          ...defaultHandler,
        });
        setErrorMessage({
          ...errorDefault,
        });
      }, 100);
    }
    if (isError) {
      setLoader(false);
    } 
  }, [
    isSuccess,
    handleCloseModal,
    // dispatch,
    isError,
    errorDefault,
    setSelectedItem,
    selectedItem,
    defaultHandler,
    message,
    setLoader,
  ]);

  const [foodCategory] = useState([
    { label: "Vegetables", value: "Vegetables", key: 1 },
    { label: "Fruits", value: "Fruits", key: 2 },
    { label: "Grains", value: "Grains", key: 3 },
    { label: "Protein Foods", value: "Protein Foods", key: 4 },
    { label: "Dairy", value: "Dairy", key: 5 },
    { label: "Oils & Solid Fats", value: "Oils & Solid Fats", key: 6 },
    { label: "Added Sugars", value: "Added Sugars", key: 7 },
    { label: "Beverages", value: "Beverages", key: 8 },
    { label: "Egg", value: "Egg", key: 9 },
    { label: "Non Veg", value: "Non Veg", key: 10 },
    { label: "Sea Food", value: "Sea Food", key: 11 },
    { label: "Dietary Fiber", value: "Dietary Fiber", key: 12 },
    { label: "Vitamins Rich", value: "Vitamins Rich", key: 13 },
    { label: "Minerals Rich", value: "Minerals Rich", key: 14 },
    { label: "Carbs Rich", value: "Carbs Rich", key: 15 },
    { label: "Protein Rich", value: "Protein Rich", key: 16 },
    { label: "Antioxidants Rich", value: "Antioxidants Rich", key: 17 },
    { label: "Anti-Inflammatory,", value: "Anti-Inflammatory,", key: 18 },
    { label: "Fibers Rich", value: "Fibers Rich", key: 19 },
    { label: "Gut Foods", value: "Gut Foods", key: 20 },
    { label: "Others", value: "Others", key: 21 },
  ]);

  const [UnitState] = useState([
    { label: "Litre", value: "Litre", key: 0 },
    { label: "Gms", value: "Gms", key: 1 },
    { label: "Ml", value: "Ml", key: 2 },
    { label: "Table Spoon", value: "Table Spoon", key: 3 },
    { label: "Tablet", value: "Tablet", key: 4 },
    { label: "Softgel", value: "Softgel", key: 4 },
    { label: "Katori", value: "Katori", key: 4 },
    { label: "Tea Cup", value: "Tea Cup", key: 4 },
    { label: "Tea Spoon", value: "Tea Spoon", key: 4 },
    { label: "Kernel", value: "Kernel", key: 4 },
    { label: "Bowl", value: "Bowl", key: 4 },
    { label: "Scoop", value: "Scoop", key: 4 },
    { label: "Piece", value: "Piece", key: 4 },
    { label: "Nuts", value: "Nuts", key: 4 },
    { label: "Servings", value: "Servings", key: 4 },
    { label: "Glass", value: "Glass", key: 4 },
    { label: "Small", value: "Small", key: 4 },
    { label: "Big", value: "Big", key: 4 },
    { label: "Medium", value: "Medium", key: 4 },
  ]);

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(null);

  // const handleCloseModal = () => {
  //   setModalOpen(false);
  // };

  const handleAddNutrition = ({ grams, unit }) => {
  const existingIndex = selectedOptions.findIndex(
    (item) => item.type === selectedType
  );

  const newItem = { type: selectedType, grams, unit: unit || "g" };

  if (existingIndex !== -1) {
    const updatedOptions = [...selectedOptions];
    updatedOptions[existingIndex] = newItem;
    setSelectedOptions(updatedOptions);
    setFormdata((prevData) => ({
      ...prevData,
      nutritions: updatedOptions,
    }));
  } else {
    const updated = [...selectedOptions, newItem];
    setSelectedOptions(updated);
    setFormdata((prevData) => ({
      ...prevData,
      nutritions: updated,
    }));
  }
  setModalOpen(false);
};
  const nutritionOptions = ["Protein", "Fat", "Carbohydrate", "Sugar", "Magnesium", "Fibre", "Calcium", "Iron"];


  const handleRemoveNutrition = (type) => {
    const updatedOptions = selectedOptions.filter((item) => item.type !== type);
    setSelectedOptions(updatedOptions);
    setFormdata((prevData) => ({ ...prevData, nutritions: updatedOptions }));
  };

  const handleChange = useCallback(
    ({ target: { name, value } }) => {
      setErrorMessage((prev) => ({
        ...prev,
        [name]: false,
      }));
      setFormdata((prev) => ({
        ...prev,
        [name]: value,
      }));
    },
    [setErrorMessage, setFormdata]
  );

  return (
    <ModalRoot
      variant="permanent"
      ownerState={{ openConfigurator: open }}
      width="50%"
    >
      <SuiBox
        style={{ whiteSpace: "normal !important" }}
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        pt={3}
        pb={0.8}
        px={3}
      >
        <ModalHeader
          mode={mode}
          title="Recipe"
          subtitle={`Recipe details for ${updateFirstLetter(formdata?.name)}`}
        />
        <Grid item xs={12}>
          {mode === "view" && (
            <Icon
              sx={({
                typography: { size, fontWeightBold },
                palette: { dark },
              }) => ({
                fontSize: `${size.md} !important`,
                fontWeight: `${fontWeightBold} !important`,
                stroke: dark.main,
                strokeWidth: "2px",
                cursor: "pointer",
                mt: 2,
                mr: 2,
              })}
              onClick={() => editHandler(selectedItem)}
            >
              edit
            </Icon>
          )}
          {mode === "edit" && (
            <Icon
              sx={({
                typography: { size, fontWeightBold },
                palette: { dark },
              }) => ({
                fontSize: `${size.md} !important`,
                fontWeight: `${fontWeightBold} !important`,
                stroke: dark.main,
                strokeWidth: "2px",
                cursor: "pointer",
                mt: 2,
                mr: 2,
              })}
              onClick={() => viewHandler(selectedItem)}
            >
              visibility
            </Icon>
          )}
          <Icon
            sx={({
              typography: { size, fontWeightBold },
              palette: { dark },
            }) => ({
              fontSize: `${size.md} !important`,
              fontWeight: `${fontWeightBold} !important`,
              stroke: dark.main,
              strokeWidth: "2px",
              cursor: "pointer",
              mt: 2,
            })}
            onClick={() => {
              handleCloseModal();
              setTimeout(() => {
                setFormdata({
                  ...defaultHandler,
                });
                setErrorMessage({
                  ...errorDefault,
                });
                if (selectedItem) {
                  setSelectedItem(null);
                }
              }, 500);
            }}
          >
            close
          </Icon>
        </Grid>
      </SuiBox>

      <Divider />

      <SuiBox pt={1.25} pb={3} px={3}>
        <SuiBox>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <SuiBox lineHeight={1}>
                <SuiTypography mb={1} variant="h6">
                  Recipe Name*
                </SuiTypography>
                <SuiInput
                  type="text"
                  disabled={mode === "view"}
                  name="name"
                  readOnly={mode === "view"}
                  autoComplete="off"
                  error={errorMessage?.name}
                  value={formdata.name ?? ""}
                  onChange={(e) => {
                    setErrorMessage({
                      ...errorMessage,
                      [e.target.name]: false,
                    });
                    setFormdata({
                      ...formdata,
                      [e.target.name]: e.target.value,
                    });
                  }}
                />
              </SuiBox>
            </Grid>

            <Grid item xs={12}>
              <SuiBox lineHeight={1}>
                <SuiTypography mb={1} variant="h6">
                  Recipe Description
                </SuiTypography>
                <RichTextEditor
                  name="description"
                  placeholder="Description about Recipe"
                  readOnly={mode === "view"}
                  rows={7}
                  error={errorMessage?.description}
                  value={formdata.description ?? ""}
                  onChange={handleChange}
                  toolbar={true}
                  height={200}
                  borderRadius={"10px"}
                />
              </SuiBox>
            </Grid>

            <Grid item xs={12}>
              <SuiBox lineHeight={1}>
                <SuiTypography mb={1} variant="h6">
                  How to Prepare
                </SuiTypography>
                <RichTextEditor
                  name="preparation"
                  readOnly={mode === "view"}
                  rows={7}
                  error={errorMessage?.preparation}
                  value={formdata.preparation ?? ""}
                  onChange={handleChange}
                  toolbar={true}
                  height={200}
                  borderRadius={"10px"}
                />
              </SuiBox>
            </Grid>

            <Grid item xs={12} md={4}>
              <SuiBox lineHeight={1}>
                <SuiTypography mb={1} variant="h6">
                  Calories
                </SuiTypography>
                <SuiInput
                  disabled={mode === "view"}
                  type="number"
                  name="calories"
                  readOnly={mode === "view"}
                  error={errorMessage?.calories}
                  value={formdata.calories ?? ""}
                  onChange={(e) => {
                    let numberRegex = /^[0-9][0-9]{0,8}?(\.[0-9]{1,2})?$/;
                    let val = e.target.value;
                    let match_ = val.match(numberRegex);
                    if (!match_ && val) {
                      return false;
                    }
                    setErrorMessage({
                      ...errorMessage,
                      [e.target.name]: false,
                    });
                    setFormdata({
                      ...formdata,
                      [e.target.name]: e.target.value,
                    });
                  }}
                />
              </SuiBox>
            </Grid>
          </Grid>
        </SuiBox>

        <SuiBox mt={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <SuiBox lineHeight={1}>
                <SuiTypography mb={1} variant="h6">
                  Food Type
                </SuiTypography>
                <MultipleTags
                  placeholder="Food type"
                  disabled={mode === "view"}
                  valList={formdata.foodType}
                  freeTextHanlder={(val) => {
                    setFormdata({
                      ...formdata,
                      foodType: val,
                    });
                  }}
                />
              </SuiBox>
            </Grid>
            <Grid item xs={12} lg={6}>
              <SuiBox lineHeight={1}>
                <SuiTypography mb={1} variant="h6">
                  Ingredients
                </SuiTypography>
                <MultipleTags
                  placeholder="ingredients"
                  disabled={mode === "view"}
                  valList={formdata.ingredients}
                  freeTextHanlder={(val) => {
                    setFormdata({
                      ...formdata,
                      ingredients: val,
                    });
                  }}
                />
              </SuiBox>
            </Grid>
            <Grid item xs={12} lg={6}>
              <SuiBox lineHeight={1}>
                <SuiTypography mb={1} variant="h6">
                  Grocery List
                </SuiTypography>
                <MultipleTags
                  placeholder="Grocery items"
                  disabled={mode === "view"}
                  valList={formdata.groceryList}
                  freeTextHanlder={(val) => {
                    setFormdata({
                      ...formdata,
                      groceryList: val,
                    });
                  }}
                />
              </SuiBox>
            </Grid>
            <Grid item xs={12} lg={4}>
              <SuiBox lineHeight={1}>
                <SuiTypography mb={1} variant="h6">
                  Nutrition Value
                </SuiTypography>
                <Autocomplete
                  multiple
                  clearIcon={null}
                  id="nutrition-input"
                  sx={{
                display: "flex",
                borderBottom: "none",
                "& input": {
                  width: 200,
                  bgcolor: "background.paper",
                  borderBottom: "none",
                },
              }}
                  options={nutritionOptions}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.type
                  }
                  value={selectedOptions.map((item) => item.type)} // array of string types
                  onChange={(event, values) => {
                    const latest = values[values.length - 1];
                    if (!selectedOptions.find((item) => item.type === latest)) {
                      setSelectedType(latest);
                      setModalOpen(true);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Nutrition"
                      variant="filled"
                      sx={{
                        "& .MuiAutocomplete-inputRoot": {
                          overflowX: "auto",
                          display: "flex !important",
                          alignItems: "flex-start !important",
                          flexWrap: "wrap !important",
                          height: "80px !important",
                          "&::after": {
                        borderBottom: "none !important",
                      },
                      "&::before": {
                        borderBottom: "none !important",
                      },
                      "&:hover": {
                        // borderBottom: 'none !important',
                        background: "red",
                      },
                        },
                      }}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((type, index) => {
                      const item = selectedOptions.find((x) => x.type === type);
                      return (
                        <Chip
                          key={type}
                          label={`${type}: ${item?.grams}${item?.unit || "g"}`}
                          {...getTagProps({ index })}
                          onDelete={() => handleRemoveNutrition(type)}
                        />
                      );
                    })
                  }
                />

                <NutritionModal
                selectedType={selectedType}
                  open={modalOpen}
                  onClose={() => {
                    setModalOpen(false);
                  }}
                  onAddNutrition={handleAddNutrition}
                />
              </SuiBox>
            </Grid>
          </Grid>
        </SuiBox>

        <SuiBox mt={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={4}>
              <SuiBox lineHeight={1}>
                <SuiTypography mb={1} variant="h6">
                  How to Take
                </SuiTypography>
                <RichTextEditor
                  name="howToTake"
                  placeholder="How to intake this recipe"
                  readOnly={mode === "view"}
                  rows={7}
                  error={errorMessage?.howToTake}
                  value={formdata.howToTake ?? ""}
                  onChange={handleChange}
                  toolbar={true}
                  height={140}
                  borderRadius={"10px"}
                />
              </SuiBox>
            </Grid>
            <Grid item xs={12} lg={4}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <SuiBox lineHeight={1}>
                    <SuiTypography mb={1} variant="h6">
                      Food Category*
                    </SuiTypography>
                    <Createable
                      options={foodCategory ?? []}
                      disabled={mode === "view"}
                      error={errorMessage.foodCategory}
                      value={formdata.foodCategory}
                      style={{ borderRadius: "0.5rem", fontSize: 14 }}
                      inputStyle={{
                        width: 190,
                        height: "1.800rem",
                        borderRadius: "0.5rem",
                      }}
                      placeholder="Choose food category"
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                        Option: InputOption, // <-- this enables checkbox style
                      }}
                      onChange={(selected) => {
                          setErrorMessage({
                            ...errorMessage,
                            foodCategory: false,
                          });
                        setFormdata({
                          ...formdata,
                          foodCategory: selected ?? [],
                        });
                      }}
                    />
                  </SuiBox>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <SuiBox lineHeight={1}>
                        <SuiTypography mb={1} variant="h6">
                          {/* {`Qty (${
                            formdata.unit?.value === "Litre"
                              ? "litre"
                              : formdata.unit?.value === "Ml"
                              ? "ml"
                              : "gms"
                          })*`} */}
                          Qty*
                        </SuiTypography>
                        <SuiInput
                          disabled={mode === "view"}
                          type="number"
                          name="qty"
                          readOnly={mode === "view"}
                          error={errorMessage?.qty}
                          value={formdata.qty ?? ""}
                          onChange={(e) => {
                            setErrorMessage({
                              ...errorMessage,
                              [e.target.name]: false,
                            });
                            setFormdata({
                              ...formdata,
                              [e.target.name]: e.target.value.replace(/\D/g),
                            });
                          }}
                        />
                      </SuiBox>
                    </Grid>
                    <Grid item xs={6}>
                      <SuiBox lineHeight={1} style={{ width: "120px" }}>
                        <SuiTypography mb={1} variant="h6">
                          Unit*
                        </SuiTypography>
                        <Createable
                          options={UnitState ?? []}
                          disabled={mode === "view"}
                          error={errorMessage.unit}
                          value={formdata.unit}
                          style={{ borderRadius: "0.5rem", fontSize: 14 }}
                          inputStyle={{
                            width: 190,
                            height: "1.800rem",
                            borderRadius: "0.5rem",
                          }}
                          placeholder="Choose unit"
                          onChange={(e) => {
                            setErrorMessage({
                              ...errorMessage,
                              unit: false,
                            });

                            setFormdata({
                              ...formdata,
                              unit: e,
                            });
                          }}
                        />
                      </SuiBox>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </SuiBox>

        <Divider />

        {mode !== "view" && (
          <SuiBox mt={3} mb={2} display="flex" justifyContent="center">
            <SuiBox mb={2} width="32%">
              <CustomButton
                color="dark"
                variant="gradient"
                onClick={submitHandler}
                fullWidth
                width={180}
                disabled={isFetching || !open}
                title={selectedItem ? "Edit Recipe" : "Add Recipe"}
                loader={isFetching}
              />
            </SuiBox>
          </SuiBox>
        )}
      </SuiBox>
    </ModalRoot>
  );
}

export default Modal;
